module.exports = __webpack_public_path__ + "static/media/phone.7bcf8d81.png";